// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import {
  QuestionBodyMeasurement,
  QuestionCondition,
  QuestionEmail,
  QuestionFiles,
  QuestionStatement,
  QuestionTextBox,
  QuestionOptions,
  QuestionPharmacySelection,
} from '../question-types'

const questionTypes = {
  bodymeasurement: QuestionBodyMeasurement,
  condition: QuestionCondition,
  file: QuestionFiles,
  statement: QuestionStatement,
  textbox: QuestionTextBox,
  email: QuestionEmail,
  option: QuestionOptions,
  pharmacyselection: QuestionPharmacySelection,
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const QuestionTypeSelector = ({ question, index }) => {
  // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
  const Component = questionTypes[question.Type]

  return (
    <>
      {index ?
        <hr className='intake-questions-divider' />
      : null}
      {Component ?
        <Component index={index + 1} {...question} />
      : null}
    </>
  )
}
